import React, { useState, useRef, useEffect } from "react";
import {
    InboxOutlined,
    SyncOutlined,
    OpenAIOutlined,
    UserOutlined,
} from "@ant-design/icons";
import "../../Components/componentsStyle.css";

import ThumbsUp from '../../Images/FeedbackThum/thumbsUp.svg'
import ThumbsDown from '../../Images/FeedbackThum/thumbsDown.svg'
import ThumbsUpFilled from '../../Images/FeedbackThum/thumbsUpFilled.svg'
import ThumbsDownFilled from '../../Images/FeedbackThum/thumbsDownFilled.svg'
import apiService from "../../Services/apiServices";


const Regenerate = (props) => {
    const { msg, fadeInProps, updateMessage, showMaximumChat, setIsFeedbackPop, index, messages ,token ,sessionId ,checkThumsDownFeedback ,showRegenerate } = props;

    // State to manage like/dislike status and whether the buttons are disabled
    const [isLiked, setIsLiked] = useState(false);
    const [isDisliked, setIsDisliked] = useState(false);
    const [isFeedbackButtonDisabled, setIsFeedbackButtonDisabled] = useState(false);

    const handleLike = () => {
        if (!isFeedbackButtonDisabled) {
            setIsLiked(true);
            setIsDisliked(false);
            setIsFeedbackButtonDisabled(true); // Disable buttons after clicking
            apiService.feedbackApi({ feedbackThumbs: 'thumsUp'   ,sessionId:sessionId})
        }
    };

    const handleDislike = () => {
        if (!isFeedbackButtonDisabled) {
            setIsFeedbackPop(true)
            setIsDisliked(true);
            setIsLiked(false);
           

        }
    };

    useEffect(()=>{
        if(index !== messages?.length -1){
            setIsFeedbackButtonDisabled(true)
        }
    })
   
    useEffect(()=>{
     
        checkThumsDownFeedback?.includes(index) && setIsFeedbackButtonDisabled(true)

    },[checkThumsDownFeedback])




    return (
        <div
            className="server-response-footer"
            style={fadeInProps}
        >
            <div
                style={{
                    display: "flex",
                    cursor: (isFeedbackButtonDisabled || showRegenerate) ? 'default' : 'pointer',
                    marginTop: '12px',
                    ...fadeInProps,
                }}
            >
                {index === messages?.length - 1  &&
                    <>
                        <SyncOutlined style={{ marginRight: 4 ,color: isFeedbackButtonDisabled || showRegenerate  ? 'gray' :'#d02f92',}} />
                        <button 
                        onClick={() => updateMessage(msg)}
                        style={{
                            color: isFeedbackButtonDisabled || showRegenerate  ? 'gray' :'#d02f92',
                            cursor: isFeedbackButtonDisabled || showRegenerate ? 'not-allowed' : 'pointer',
                            pointerEvents: isFeedbackButtonDisabled || showRegenerate  ? 'none' : 'auto',
                            border : 'none',
                          }}
                          disabled ={isFeedbackButtonDisabled || showRegenerate }
                        >Regenerate</button>
                    </>
                }
            </div>
            <div style={{ display: 'flex' }}>
                {showMaximumChat && msg?.llm_response?.Doc_version && (
                    <div className="version">
                       {msg?.llm_response?.Doc_version && <>Version</>} {msg?.llm_response?.Doc_version} ({msg?.llm_response?.Doc_updated_on})
                    </div>
                )}
                <div style={{ marginTop: '12px' }}>
                    <img
                        style={{ width: '24px', height: '28px', cursor: isFeedbackButtonDisabled ? 'default' : 'pointer' }}
                        src={isLiked ? ThumbsUpFilled : ThumbsUp}
                        alt={isLiked ? "ThumbsUpFilled" : "ThumbsUp"}
                        onClick={handleLike}
                    />
                    <img
                        style={{ width: '24px', height: '28px', cursor: isFeedbackButtonDisabled ? 'default' : 'pointer' }}
                        src={isDisliked && checkThumsDownFeedback?.includes(index)? ThumbsDownFilled : ThumbsDown}
                        alt={isDisliked ? "ThumbsDownFilled" : "ThumbsDown"}
                        onClick={handleDislike}
                    />
                </div>
            </div>
        </div>
    );
};

export default Regenerate
